import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import { spacing } from '../../../styles/theme';

// Container principal
export const ActionButtonsContainer = styled(Box)(({ theme }) => ({
  padding: 0,
  backgroundColor: 'transparent',
}));

// Container de botones
export const ButtonsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: spacing.sm,
  justifyContent: 'flex-start',
}));

// Botón principal (Añadir) - Igual al ProductCatalog
export const AddButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  padding: theme.spacing(1, 2),
  borderRadius: '8px',
  background: 'linear-gradient(to right, #06b6d4, #10b981)',
  color: 'white',
  '&:hover': {
    background: 'linear-gradient(to right, #0891b2, #059669)',
  },
}));

// Botón secundario (Importar/Exportar) — coherente con catálogo (tema)
export const SecondaryButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  padding: theme.spacing(1, 2),
  borderRadius: '8px',
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.divider}`,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    borderColor: theme.palette.text.secondary,
  },
}));

// Botón oculto (para futuras implementaciones)
export const HiddenButton = styled(Button)(({ theme }) => ({
  display: 'none',
}));
